module.exports = "/_next/static/images/cf65c5ae9d45f066f9a5db61449d6628-boy-looking-to-the-front-lg@3x.jpg.webp";